/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateMyBrandingRequest
 */
export interface UpdateMyBrandingRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateMyBrandingRequest
     */
    agentName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyBrandingRequest
     */
    agentEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyBrandingRequest
     */
    agentTitle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyBrandingRequest
     */
    agentAvatar?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyBrandingRequest
     */
    agentMlsId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyBrandingRequest
     */
    agentPhoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyBrandingRequest
     */
    officeName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyBrandingRequest
     */
    officeLogo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyBrandingRequest
     */
    website?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyBrandingRequest
     */
    teamName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyBrandingRequest
     */
    teamLogo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyBrandingRequest
     */
    instagramUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyBrandingRequest
     */
    facebookUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyBrandingRequest
     */
    xUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyBrandingRequest
     */
    youtubeUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyBrandingRequest
     */
    linkedInUrl?: string | null;
}

/**
 * Check if a given object implements the UpdateMyBrandingRequest interface.
 */
export function instanceOfUpdateMyBrandingRequest(value: object): value is UpdateMyBrandingRequest {
    return true;
}

export function UpdateMyBrandingRequestFromJSON(json: any): UpdateMyBrandingRequest {
    return UpdateMyBrandingRequestFromJSONTyped(json, false);
}

export function UpdateMyBrandingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateMyBrandingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'agentName': json['agentName'] == null ? undefined : json['agentName'],
        'agentEmail': json['agentEmail'] == null ? undefined : json['agentEmail'],
        'agentTitle': json['agentTitle'] == null ? undefined : json['agentTitle'],
        'agentAvatar': json['agentAvatar'] == null ? undefined : json['agentAvatar'],
        'agentMlsId': json['agentMlsId'] == null ? undefined : json['agentMlsId'],
        'agentPhoneNumber': json['agentPhoneNumber'] == null ? undefined : json['agentPhoneNumber'],
        'officeName': json['officeName'] == null ? undefined : json['officeName'],
        'officeLogo': json['officeLogo'] == null ? undefined : json['officeLogo'],
        'website': json['website'] == null ? undefined : json['website'],
        'teamName': json['teamName'] == null ? undefined : json['teamName'],
        'teamLogo': json['teamLogo'] == null ? undefined : json['teamLogo'],
        'instagramUrl': json['instagramUrl'] == null ? undefined : json['instagramUrl'],
        'facebookUrl': json['facebookUrl'] == null ? undefined : json['facebookUrl'],
        'xUrl': json['xUrl'] == null ? undefined : json['xUrl'],
        'youtubeUrl': json['youtubeUrl'] == null ? undefined : json['youtubeUrl'],
        'linkedInUrl': json['linkedInUrl'] == null ? undefined : json['linkedInUrl'],
    };
}

export function UpdateMyBrandingRequestToJSON(json: any): UpdateMyBrandingRequest {
    return UpdateMyBrandingRequestToJSONTyped(json, false);
}

export function UpdateMyBrandingRequestToJSONTyped(value?: UpdateMyBrandingRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'agentName': value['agentName'],
        'agentEmail': value['agentEmail'],
        'agentTitle': value['agentTitle'],
        'agentAvatar': value['agentAvatar'],
        'agentMlsId': value['agentMlsId'],
        'agentPhoneNumber': value['agentPhoneNumber'],
        'officeName': value['officeName'],
        'officeLogo': value['officeLogo'],
        'website': value['website'],
        'teamName': value['teamName'],
        'teamLogo': value['teamLogo'],
        'instagramUrl': value['instagramUrl'],
        'facebookUrl': value['facebookUrl'],
        'xUrl': value['xUrl'],
        'youtubeUrl': value['youtubeUrl'],
        'linkedInUrl': value['linkedInUrl'],
    };
}

